/**
 * NOTE:
 *
 * This file is automatically generated by i18n-tools.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
// Romanian
export default {
  'fabric.atlassianSwitcher.switchTo': 'Comutați la',
  'fabric.atlassianSwitcher.switchToTooltip': 'Comutați la…',
  'fabric.atlassianSwitcher.recent': 'Recente',
  'fabric.atlassianSwitcher.more': 'Mai mult',
  'fabric.atlassianSwitcher.try': 'Încercați',
  'fabric.atlassianSwitcher.manageList': 'Gestionați lista',
  'fabric.atlassianSwitcher.jiraProject': 'Proiect Jira',
  'fabric.atlassianSwitcher.confluenceSpace': 'Spațiu Confluence',
  'fabric.atlassianSwitcher.people': 'Persoane',
  'fabric.atlassianSwitcher.administration': 'Administrare',
  'fabric.atlassianSwitcher.discoverMore': 'Descoperiți mai multe',
  'fabric.atlassianSwitcher.errorHeading': 'Ceva nu a funcționat corect',
  'fabric.atlassianSwitcher.errorText': 'Monitorizăm erorile de acest tip, însă ne puteți contacta dacă reîmprospătarea nu îmbunătățește lucrurile',
  'fabric.atlassianSwitcher.errorImageAltText': 'Un robot este defect și câțiva oameni sunt ocupați să îl repare. ',
  'fabric.atlassianSwitcher.expand': 'Extindere'
};